import angular from 'angular';
import {Module, Service} from './../decorators';
import R from './../resource';


@Module({
    name: 'app.services.config',
    modules: [R],
})
@Service('Config')
export default class Config {
    constructor ($q, R) {
        "ngInject";
        this.endpoint = R.one('config');
        this.deferred = $q.defer();
        this.promise = this.deferred.promise;
        this.reset();
    }

    reset () {
        this.$config = {
            dateFormat: 'YYYY-MM-DD',
        };
    }

    isFeatureFlagActive (name, defaultActive = true) {
        const featureFlags = this.$config.feature_flags || {};
        const switches = featureFlags.switches || [];
        const featureFlag = switches.find((item) => item.name === name);
        return featureFlag ? featureFlag.active : defaultActive;
    }

    refresh () {
        let self = this;
        this.endpoint.get().then(function (response) {
            angular.extend(self.$config, response.plain());
            self.deferred.resolve(self);
        });
        return self.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/config.js